import type { TInformationType } from '../information.provider.types';

import type { InformationReducerAction, InformationReducerState } from './information.reducer.types';

function informationReducer(state: InformationReducerState, action: InformationReducerAction): InformationReducerState {
  const {
          type,
          payload,
        } = action;

  switch (type) {
    case 'change-tab': {
      const [, type]   = /^(questions|terminology).*$/.exec(payload.page) ?? [];
      const isInterior = /_interior$/.test(payload.page);

      return {
        ...state,
        isInterior,
        isLoaded: false,
        items:    [],
        loading:  false,
        template: payload.page,
        type:     type as TInformationType,
      };
    }

    case 'get-initial-state_failure':
      return {
        ...state,
        loading: false,
      };

    case 'get-initial-state_request': {
      const [, type]   = /^(questions|terminology).*$/.exec(payload.page) ?? [];
      const isInterior = /_interior$/.test(payload.page);

      return {
        ...state,
        isInterior,
        isLoaded: false,
        items:    [],
        loading:  true,
        template: payload.page,
        type:     type as TInformationType,
      };
    }

    case 'get-initial-state_success': {
      return {
        ...state,
        isLoaded:  true,
        items:     payload.items ?? [],
        loading:   false,
        promotion: payload.promotion?.[0],
      };
    }

    default:
      return { ...state };
  }
}

export default informationReducer;